/**
 * @author      hugo@zumper.com (Hugo Pineda)
 * @copyright   Copyright (c) 2023, Zumper
 */

export const toExpandableLinkObject = ({ title, to }: { title: string; to: string }) => ({
  eventName: title,
  linkName: to,
  title,
  to,
})
